<div fxLayout="column" fxHide.lt-md>
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else quickpaypaymentNoteListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="quickpaypaymentNoteListFlexColumnTemplate"></ng-container>
    </div>
</div>

<div fxLayout="column" fxHide.gt-sm ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <ng-container *ngTemplateOutlet="quickpayPaymentNoteListCardViewTemplate"></ng-container>
</div>

<ng-template #quickpayPaymentNoteListCardViewTemplate>

    <div fxLayout="column">

        <ng-container *ngFor="let row of openNotesQuickPayPaymentInfoListWithFooters">

            <ng-container *ngIf="row.hasOwnProperty('isGroupFooter')">
                <mat-card style="background-color: #e3f2fd;">
                    <mat-card-title>
                        <span class="header-superscript" [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                            i18n="@@quick-pay-payment-amount.table.group-footer.pay-group">quick-pay-payment-amount.table.group-footer.pay-group</span>
                    </mat-card-title>
                    <mat-card-content>

                        <div style="display: flex; justify-content: space-between;">
                            <mat-label><span class="header-superscript header-after-content-3"
                                    [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                    i18n="@@payment-note-list.table.column-header.total-amount-due">payment-note-list.table.column-header.total-amount-due</span></mat-label>
                            <span style="text-align: right;">{{
                                row.totalAmountDueTotal | currency
                                }}</span>
                        </div>

                    </mat-card-content>
                    <mat-card-actions style="display: flex; justify-content: right; align-items: right;">
                        <button mat-flat-button color="primary" (click)="selectPayGroup(row.paymentGroup)"
                            i18n-matTooltip="@@payment-note-list.table.column.options.button.tool-tip"
                            matTooltip="payment-note-list.table.column.options.button.tool-tip"
                            i18n="@@payment-note-list.table.column.options.button.label">
                            payment-note-list.table.column.options.button.label
                        </button>
                    </mat-card-actions>
                </mat-card>
            </ng-container>

            <ng-container *ngIf="!row.hasOwnProperty('isGroupFooter')">
                <mat-card *ngIf="row.noteId">
                    <mat-card-content>
                        <div style="width: 100%;">
                            <!-- Left Section: Note ID and Note Status -->
                            <div>
                                <mat-card-title>{{ row.noteId }}
                                </mat-card-title>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }" class="header-superscript header-after-content-5"
                                            i18n="@@payment-note-list.table.column-header.next-payment-due-date">payment-note-list.table.column-header.next-payment-due-date</span></mat-label>
                                    <span style="text-align: right;">{{ row.nextPaymentDueDate }}</span>
                                </div>
                                <div style="display: flex; justify-content: space-between;">
                                    <mat-label><span class="header-superscript header-after-content-3"
                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                            i18n="@@payment-note-list.table.column-header.total-amount-due">payment-note-list.table.column-header.total-amount-due</span></mat-label>
                                    <span style="text-align: right;">{{
                                        row.totalAmountDue | currency
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions style="display: flex; justify-content: right; align-items: right;">
                        <button mat-flat-button color="primary" (click)="selectNote(row.noteId)"
                            i18n-matTooltip="@@payment-note-list.table.column.options.button.tool-tip"
                            matTooltip="payment-note-list.table.column.options.button.tool-tip"
                            i18n="@@payment-note-list.table.column.options.button.label">
                            payment-note-list.table.column.options.button.label
                        </button>
                    </mat-card-actions>
                </mat-card>
            </ng-container>
        </ng-container>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesQuickPayPaymentInfoListFound && displayNotices">
        <div *ngIf="isBrowserIE; else quickpaypaymentNoteListNoticesFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="quickpaypaymentNoteListNoticesFlexColumnTemplate"></ng-container>
        </div>
    </div>

</ng-template>

<ng-template #quickpaypaymentNoteListFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
        </div>
        <div fxLayout="column" *ngIf="!showSpinner">
            <div *ngIf="isBrowserIE; else quickpaypaymentNoteListTableFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="quickpaypaymentNoteListTableFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #quickpaypaymentNoteListTableFlexColumnTemplate>
    <div fxFlex="100%" class="display-text primary-dark-color-important" *ngIf="displayTitle">
        <b><span i18n="@@quick-pay-payment-note-list.table.title">quick-pay-payment-note-list.table.title</span></b>
    </div>

    <div fxFlex="100%" class="display-text title-spacer" *ngIf="!openNotesQuickPayPaymentInfoListFound">
        <i><span
                i18n="@@quick-pay-payment-note-list.table.no-records">quick-pay-payment-note-list.table.no-records</span></i>
    </div>

    <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
        <mat-table #table [dataSource]="tableDataSource" ngClass.lt-md="small-table-text">
            <!-- noteId Column -->
            <ng-container matColumnDef="noteId">
                <mat-header-cell *matHeaderCellDef fxFlex="19%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@quick-pay-payment-note-list.table.column-header.note-id">quick-pay-payment-note-list.table.column-header.note-id</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="19%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.noteId
                    }}</mat-cell>
            </ng-container>
            <!-- nextPaymentDueDate Column -->
            <ng-container matColumnDef="nextPaymentDueDate">
                <mat-header-cell *matHeaderCellDef fxFlex="19%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@quick-pay-payment-note-list.table.column-header.next-payment-due-date">quick-pay-payment-note-list.table.column-header.next-payment-due-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="19%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.nextPaymentDueDate
                    }}</mat-cell>
            </ng-container>
            <!-- totalAmountDue Column -->
            <ng-container matColumnDef="totalAmountDue">
                <mat-header-cell *matHeaderCellDef fxFlex="19%">
                    <span class="header-superscript header-after-content-3"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@quick-pay-payment-note-list.table.column-header.total-amount-due">quick-pay-payment-note-list.table.column-header.total-amount-due</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="19%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.totalAmountDue | currency
                    }}</mat-cell>
            </ng-container>
            <!-- options Column -->
            <ng-container matColumnDef="options">
                <mat-header-cell *matHeaderCellDef fxFlex="19%">
                    <span class="header-superscript header-after-content-5" *ngIf="QuickPay_CompanyCode_Check()"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@quick-pay-payment-note-list.table.column-header.options">quick-pay-payment-note-list.table.column-header.options</span>
                    <span *ngIf="!QuickPay_CompanyCode_Check()" [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@quick-pay-payment-note-list.table.column-header.options">quick-pay-payment-note-list.table.column-header.options</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="19%" class="mat-column-data-centered"
                    ngClass.lt-md="small-table-text">
                    <span [ngClass]="{ 'mat-column-options-ie': isBrowserIE }">
                        <button mat-flat-button color="primary" fxHide.lt-md (click)="selectNote(row.noteId)"
                            i18n-matTooltip="@@quick-pay-payment-note-list.table.column.options.button.tool-tip"
                            matTooltip="quick-pay-payment-note-list.table.column.options.button.tool-tip"
                            i18n="@@quick-pay-payment-note-list.table.column.options.button.label">
                            quick-pay-payment-note-list.table.column.options.button.label
                        </button>
                        <a class="button-link" fxHide.gt-sm (click)="selectNote(row.noteId)"
                            i18n-matTooltip="@@quick-pay-payment-note-list.table.column.options.anchor.tool-tip"
                            matTooltip="quick-pay-payment-note-list.table.column.options.anchor.tool-tip"
                            i18n="@@quick-pay-payment-note-list.table.column.options.anchor.label">quick-pay-payment-note-list.table.column.options.anchor.label</a>
                    </span>
                </mat-cell>
            </ng-container>

            <!-- Group Footer -->
            <ng-container matColumnDef="groupFooterTotals">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }"
                    style="padding-right: 20px; text-align: right;" mat-cell *matCellDef="let groupFooter" fxFlex="38%"
                    fxLayoutAlign="end center">
                    <strong><span
                            i18n="@@quick-pay-payment-note-list.table.group-footer.pay-group">quick-pay-payment-note-list.table.group-footer.pay-group</span>:</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterTotalAmountDueTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="19%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.totalAmountDueTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterOptions">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="19%" fxLayoutAlign="start center">
                    <span [ngClass]="{ 'mat-column-options-ie': isBrowserIE }">
                        <button mat-flat-button color="primary" fxHide.lt-md
                            (click)="selectPayGroup(groupFooter.paymentGroup)"
                            i18n-matTooltip="@@quick-pay-payment-note-list.table.group-footer.options.button.tool-tip"
                            matTooltip="quick-pay-payment-note-list.table.column.options.button.tool-tip"
                            i18n="@@quick-pay-payment-note-list.table.group-footer.options.button.label">
                            quick-pay-payment-note-list.table.group-footer.options.button.label
                        </button>
                        <a class="button-link" fxHide.gt-sm (click)="selectPayGroup(groupFooter.paymentGroup)"
                            i18n-matTooltip="@@quick-pay-payment-note-list.table.group-footer.options.anchor.tool-tip"
                            matTooltip="quick-pay-payment-note-list.table.group-footer.options.anchor.tool-tip"
                            i18n="@@quick-pay-payment-note-list.table.group-footer.options.anchor.label">quick-pay-payment-note-list.table.group-footer.options.anchor.label</a>
                    </span>
                </td>
            </ng-container>
            <tr mat-row class="mat-row-group-footer" *matRowDef="
          let row;
          columns: [
            'groupFooterTotals',
            'groupFooterTotalAmountDueTotal',
            'groupFooterOptions'
          ];
          when: isGroupFooter
        "></tr>
            <mat-header-row class="primary-light-bg-top-to-bottom-gradient" *matHeaderRowDef="tableDisplayedColumns"
                ngClass.lt-md="small-header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"
                [ngClass]="{ 'primary-lightest-bg': row.noteId === selectedNoteId }"></mat-row>
        </mat-table>

        <div fxLayoutAlign="end center" class="small-display-text primary-light-color"
            *ngIf="openNotesQuickPayPaymentInfoListFound">
            <app-table-record-count [recordCount]="openNotesQuickPayPaymentInfoList.length"
                i18n-singularLabel="@@quick-pay-payment-note-list.table.record-count.singular-label"
                singularLabel="quick-pay-payment-note-list.table.record-count.singular-label"
                i18n-multipleLabel="@@quick-pay-payment-note-list.table.record-count.multiple-label"
                multipleLabel="quick-pay-payment-note-list.table.record-count.multiple-label"></app-table-record-count>
        </div>
        <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesQuickPayPaymentInfoListFound && displayNotices">
            <div *ngIf="isBrowserIE; else quickpaypaymentNoteListNoticesFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="quickpaypaymentNoteListNoticesFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #quickpaypaymentNoteListNoticesFlexColumnTemplate>
    <div fxFlex="100%" class="display-text">
        <sup>3</sup>&nbsp;<span
            i18n="@@quick-pay-payment-note-list.notices.3">quick-pay-payment-note-list.notices.3</span>
    </div>
    <div fxFlex="100%" class="display-text" *ngIf="QuickPay_CompanyCode_Check()">
        <sup>5</sup>&nbsp;<b><span
                i18n="@@quick-pay-payment-note-list.notices.5a">quick-pay-payment-note-list.notices.5a</span>&nbsp;
            <a target="_blank" href="https://www.tuitionoptions.com/about-payments">
                <span i18n="@@quick-pay-payment-note-list.notices.5b">quick-pay-payment-note-list.notices.5b</span>
            </a>&nbsp;
            <span i18n="@@quick-pay-payment-note-list.notices.5c">quick-pay-payment-note-list.notices.5c</span>
        </b>
    </div>
</ng-template>